export const iconFontAwesomePhotosImagesCameraRetro = (
	<i className="fa-solid fa-camera-retro"></i>
);
